export default __webpack_public_path__ + "slices/main/assets/public/podcast-subscribe-toggle/google-play.9b16af32fa2337a91f3287bc1ac11e81.svg";